import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ConcreteCIconProps {
  size?: number;
  color?: string;
}

const ConcreteCIcon: React.FC<ConcreteCIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-concretec">
    {
      <path
        d="M20.581 12c0 4.739-3.842 8.581-8.581 8.581s-8.581-3.842-8.581-8.581c0-4.739 3.842-8.581 8.581-8.581s8.581 3.842 8.581 8.581z"
      />}  </SvgIcon>
);

export default ConcreteCIcon;
